import { RevealPanel } from '../classes/revealPanel';

interface MenuSection {
    trigger: HTMLButtonElement;
    panel: HTMLElement;
}

class DesktopNavigation {
    container: HTMLElement;
    menuSections: Array<MenuSection>;
    searchPanel: RevealPanel;
    constructor(desktopNavContainer) {
        this.menuSections = [];
        this.container = desktopNavContainer;
        this.searchPanel = null;
    }

    init() {
        const menuList = this.container.querySelector('#Nav_desktop_main') as HTMLUListElement;
        const menuListItems = [].slice.call(menuList.children);
        this.searchPanel = new RevealPanel('Nav_desktop_search_panel');
        menuListItems.forEach(listItem => {
            const triggerChild = listItem.querySelector('[aria-haspopup]') as HTMLButtonElement;
            if (triggerChild) {
                this.menuSections.push({
                    trigger: triggerChild,
                    panel: triggerChild.nextElementSibling as HTMLElement
                });
            }
        });

        this.menuSections.forEach(section => {
            section.trigger.addEventListener('click', () => {
                this.togglePanel(section);
            });
            const closeBtn = section.panel.querySelector('[aria-controls]') as HTMLButtonElement;
            closeBtn.addEventListener('click', () => {
                this.closePanel(section);
            })
        });

        document.body.addEventListener('click', (e: Event) => {
            const clickedOutsideOfNav = !this.container.contains(e.target as Element);
            if (clickedOutsideOfNav) {
                this.closeAllPanels();
            }
        });

        document.body.addEventListener('keyup', (e: KeyboardEvent) => {
            if (e.which == 27) {
                this.closeAllPanels();
            }
        });
        this.addUnderlineToMenu();
    }

    togglePanel(section: MenuSection) {
        if (section.trigger && section.panel) {
            if (section.trigger.getAttribute('aria-expanded') == 'true') {
                this.closePanel(section);
            }
            else {
                this.openPanel(section);
            }
        }
    }

    openPanel(section: MenuSection) {
        this.menuSections.forEach(sectionInList => {
            if (section.trigger != sectionInList.trigger) {
                this.closePanel(sectionInList);
            }
        })
        section.trigger.setAttribute('aria-expanded', 'true');
        section.panel.setAttribute('aria-hidden', 'false');
    }

    closePanel(section: MenuSection) {
        section.trigger.setAttribute('aria-expanded', 'false');
        section.panel.setAttribute('aria-hidden', 'true');
    }

    closeAllPanels() {
        this.menuSections.forEach(sectionInList => {
            this.closePanel(sectionInList);
        });
        if (this.searchPanel.isOpen) {
            this.searchPanel.closePanel();
        }
    }
    addUnderlineToMenu() {
        /* Adds yellow border to main navigation based off page URL */
        var pathBorder = window.location.pathname.split('/');
        var pageTitleBorder = pathBorder[1];
        var mainNavBorder = document.getElementById('Nav_desktop_main');
        const utilityNavBorder = document.getElementsByClassName('nav-utility-list')[0];

        // if we haven't found a match yet, try checking all the urls we can find under each meganav item to see if anything matches on url
        const checkItems = mainNavBorder.children;
        // @ts-ignore
        for (const topLevel of checkItems) {
            const links = [...topLevel.querySelectorAll('a')].map(a => (new URL(a.href)).pathname.replace(/\/$/, ''));
            const parentUrls = [];
            window.location.pathname
                .split('/')
                .filter(part => !!part)
                .reduce((acc, val, idx) => {
                    const url = acc + '/' + val
                    parentUrls.push(url);
                    return url;
                }, '');

            for (const parent of parentUrls) {
                if (links.some(link => link == parent)) {
                    topLevel.children[0].classList.add('nav-link', 'w--current');
                    break;
                }
            }
        }


        if (utilityNavBorder) {
            const checkItems = utilityNavBorder.children;
            // @ts-ignore
            for (const topLevel of checkItems) {
                const links = [...topLevel.querySelectorAll('a')].map(a => (new URL(a.href)).pathname.replace(/\/$/, ''));
                const parentUrls = [];
                window.location.pathname
                    .split('/')
                    .filter(part => !!part)
                    .reduce((acc, val, idx) => {
                        const url = acc + '/' + val
                        parentUrls.push(url);
                        return url;
                    }, '');

                for (const parent of parentUrls) {
                    if (links.some(link => link == parent)) {
                        topLevel.classList.add('w--current');
                        break;
                    }
                }
            }
            /*
            for (let i = 0; i < utilityNavBorder.children.length; i++) {
                const child = utilityNavBorder.children[i].children[0];
                if (pageTitleBorder == child.textContent.toLocaleLowerCase()) {
                    utilityNavBorder.children[i].classList.add('w--current');
                }
            }
            */
        }
    }
}

let DesktopNav: DesktopNavigation;
const desktopNavContainer = document.querySelector('#Nav_desktop') as HTMLElement;
if (desktopNavContainer) {
    DesktopNav = new DesktopNavigation(desktopNavContainer);
}

export { DesktopNav };